import { useAppModals } from "../../../../../app/state/modalSlice/hook/use-app-modals";
import { AlertButton } from "../../../../../common/Components/Buttons/AlertButton";
import { useAppSelector } from "../../../../../services/redux/hooks/use-selector";
import { AppButton } from "../../../../../shared/components/AppButton";
import { selectIsProfileFilled, selectProfile } from "../../redux/selectors";
import styles from "./styles.module.css";

interface Props {
  className?: string;
}

export const ProfileButton = ({ className }: Props) => {
  const isProfileFilled = useAppSelector(selectIsProfileFilled);
  const profile = useAppSelector(selectProfile);
  const { handleOpenModal } = useAppModals();
  return (
    <>
      {!isProfileFilled && (
        <AlertButton
          title={"Укажите имя и стол"}
          onClick={() => handleOpenModal("profile_modal", null)}
        />
      )}
      {isProfileFilled && (
        <AppButton
          buttonType={"text"}
          onClick={() => handleOpenModal("profile_modal", null)}
          className={styles["profile-btn"]}
        >{`${profile.username}_стол: ${profile.usertable}`}</AppButton>
      )}
    </>
  );
};
